import React from "react";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import { DialogContent, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Table from "../../../../component-lib/Organisms/table/EventEHRTable";
import moment from "moment";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    width: "100vh", // Set your custom width here
    maxWidth: "none", // Prevents Material-UI from overriding your width
  },
}));

interface TriageHistoryDialogProps {
  open: boolean;
  triageData: any;
  handleClose: () => void;
}

const TriageHistoryDialog = ({
  open,
  triageData,
  handleClose,
}: TriageHistoryDialogProps) => {
  const triageHistoryColumns = [
    {
      field: "takenBy",
      label: <div>Vitals Taken By</div>,
      renderLogic: (row: any) => {
        return (
          <p className="text-neutral-90 font-normal">{row?.triageTakenBy}</p>
        );
      },
    },
    {
      field: "temperature",
      label: <div>Temperature</div>,
      renderLogic: (row: any) => {
        return (
          <p className="text-neutral-90 font-normal">{row?.temperature}</p>
        );
      },
    },
    {
      field: "oxygenSaturation",
      label: <div>Oxygen Saturation</div>,
      renderLogic: (row: any) => {
        return (
          <p className="font-medium text-neutral-90 cursor-pointer">
            {row?.oxygenSaturation}
          </p>
        );
      },
    },
    {
      field: "heartRate",
      label: <div>Heart Rate</div>,
      renderLogic: (row: any) => {
        return <p className="text-neutral-90 font-normal">{row?.heartRate}</p>;
      },
    },
    {
      field: "respirationRate",
      label: <div>Respiration Rate</div>,
      renderLogic: (row: any) => {
        return (
          <p className="text-neutral-90 font-normal">{row?.respirationRate}</p>
        );
      },
    },
    {
      field: "bloodPressure",
      label: <div>Blood Pressure</div>,
      renderLogic: (row: any) => {
        return <p className="text-neutral-90 font-normal">{row?.pressure}</p>;
      },
    },
    {
      field: "triageTakenDate",
      label: <div>Vitals Taken On</div>,
      renderLogic: (row: any) => {
        return (
          <p className="text-neutral-90 font-normal">{row?.triageTakenDate}</p>
        );
      },
    },
  ];

  const triageRowData = triageData?.map((data: any) => ({
    temperature: data?.temperature || "-",
    oxygenSaturation: data?.oxygenSaturation || "-",
    heartRate: data?.heartRate || "-",
    respirationRate: data?.respirationRate || "-",
    pressure:
      data?.systolic && data?.diastolic
        ? data?.systolic + "/" + data?.diastolic
        : "-",
    triageTakenBy:
      data?.takeBy?.firstName && data?.takeBy?.lastName
        ? data?.takeBy?.firstName + " " + data?.takeBy?.lastName
        : "-",
    triageTakenDate: data?.createdAt
      ? moment(data.createdAt).format("MM/DD/YYYY hh:mm A")
      : "-",
  }));

  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            handleClose();
          }
        }}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle
          sx={{ m: 0, p: 2, fontWeight: 600, fontSize: "18px" }}
          id="customized-dialog-title"
        >
          Vitals History
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <hr />
        <DialogContent style={{ maxHeight: "70vh" }}>
          <Table columns={triageHistoryColumns} rows={triageRowData} />
        </DialogContent>
      </BootstrapDialog>
    </React.Fragment>
  );
};

export default TriageHistoryDialog;
